import {
  WBButton,
  WBFlex,
  WBLinkButton,
  WBTypography,
} from '@admiin-com/ds-web';
import React, { ReactNode } from 'react';
import LottieAnimation from '../LottieAnimation/LottieAnimation';
import { t } from 'i18next';

interface Props {
  onGetStarted?: () => void;
  title?: string;
  description?: string | ReactNode;
  buttonTitle?: string;
  disabled?: boolean;
  loading?: boolean;
  lottiePath?: string;
  segment?: [number, number];
  onClose?: () => void;
  closeButtonText?: string;
}

const OnboardingMessage: React.FC<Props> = ({
  title,
  description,
  disabled = false,
  loading = false,
  buttonTitle,
  onGetStarted,
  lottiePath,
  segment,
  onClose,
  closeButtonText,
}: Props) => {
  return (
    <WBFlex
      flexDirection={'column'}
      alignItems={'center'}
      rowGap={[1.5, 2.5]}
      sx={{
        backgroundColor: 'background.paper',
        padding: { xs: 1, sm: 20 },
        paddingTop: { xs: 1, sm: 5 },
        paddingBottom: { xs: 5, sm: 20 },
        marginTop: { xs: 1, sm: 0 },
      }}
    >
      <WBFlex
        sx={{
          backgroundColor: 'transparent',
          borderRadius: '100%',
          width: '200px',
          height: '100px',
        }}
      >
        {lottiePath && <LottieAnimation path={lottiePath} segment={segment} />}
      </WBFlex>
      <WBTypography textAlign={'center'} variant={'h3'}>
        {title}
      </WBTypography>
      <WBTypography
        textAlign={'center'}
        typography={['body2', 'body1']}
        color="text.secondary"
      >
        {description}
      </WBTypography>
      {onGetStarted && (
        <WBButton
          onClick={onGetStarted}
          disabled={disabled}
          loading={loading}
          sx={{
            padding: { xs: '16px 0', sm: '16px 192px' },
            width: { xs: '100%', sm: 'auto' },
            flexWrap: 'nowrap',
          }}
        >
          {buttonTitle}
        </WBButton>
      )}
      {onClose && (
        <WBLinkButton color="primary.main" onClick={onClose}>
          {closeButtonText ?? t('backToTaskbox', { ns: 'taskbox' })}
        </WBLinkButton>
      )}
    </WBFlex>
  );
};

export default OnboardingMessage;
